import { t } from './i18n.js';

const panelMap = {
  players: '.players-section',
  actions: '.action-section',
  history: '.log-section',
  chat: '.chat-section',
};

function icon(name) {
  const paths = {
    mark: '<path d="M5 8h14l2 8-4 3-3-3H10l-3 3-4-3 2-8Z"/><circle cx="9" cy="12" r="1"/><path d="M15 11v3M13.5 12.5h3"/>',
    players: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>',
    actions: '<path d="m13 2-2 8h7l-7 12 2-8H6l7-12Z"/>',
    history: '<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5M12 7v5l3 2"/>',
    chat: '<path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8Z"/>',
    fullscreen: '<path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5"/>',
    sidebar: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M15 4v16"/>',
    haptics: '<path d="M8 9a5 5 0 0 0 0 6M5 6a9 9 0 0 0 0 12M16 8l-4 4 4 4M20 5l-7 7 7 7"/>',
    sound: '<path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18 6a9 9 0 0 1 0 12"/>',
    soundOff: '<path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="m17 10 4 4m0-4-4 4"/>',
  };
  return `<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths[name] || ''}</svg>`;
}

function enhanceBranding() {
  document.querySelectorAll('.logo, .auth-title').forEach((el) => {
    const text = el.textContent.replace(/^[^\p{L}]+/u, '').trim();
    el.innerHTML = `<span class="brand-mark">${icon('mark')}</span><span>${text}</span>`;
  });
}

function addHeaderControls() {
  const controls = document.querySelector('#game-header .game-header-right');
  if (!controls || document.getElementById('v2-fullscreen-btn')) return;

  const sidebar = document.createElement('button');
  sidebar.id = 'v2-sidebar-btn';
  sidebar.className = 'btn btn-sm btn-outline v2-icon-btn';
  sidebar.title = t('shell.sidebar');
  sidebar.setAttribute('aria-label', t('shell.sidebar'));
  sidebar.innerHTML = icon('sidebar');
  sidebar.addEventListener('click', () => {
    const game = document.getElementById('game-screen');
    game.classList.toggle('sidebar-collapsed');
    sidebar.setAttribute('aria-pressed', String(game.classList.contains('sidebar-collapsed')));
  });

  const fullscreen = document.createElement('button');
  fullscreen.id = 'v2-fullscreen-btn';
  fullscreen.className = 'btn btn-sm btn-outline v2-icon-btn';
  fullscreen.title = t('shell.fullscreen');
  fullscreen.setAttribute('aria-label', t('shell.fullscreen'));
  fullscreen.innerHTML = icon('fullscreen');
  fullscreen.addEventListener('click', async () => {
    try {
      if (document.fullscreenElement) await document.exitFullscreen();
      else await document.documentElement.requestFullscreen();
    } catch (error) {
      window.RendererV2?.announce(error.message, 'assertive');
    }
  });

  const haptics = document.createElement('button');
  haptics.id = 'v2-haptics-btn';
  haptics.className = 'btn btn-sm btn-outline v2-icon-btn';
  haptics.innerHTML = icon('haptics');
  const updateHaptics = () => {
    const enabled = localStorage.getItem('lan-games-haptics') !== 'off';
    const label = t(enabled ? 'shell.hapticsOn' : 'shell.hapticsOff');
    haptics.title = label;
    haptics.setAttribute('aria-label', label);
    haptics.setAttribute('aria-pressed', String(enabled));
  };
  haptics.addEventListener('click', () => {
    const enabled = localStorage.getItem('lan-games-haptics') !== 'off';
    localStorage.setItem('lan-games-haptics', enabled ? 'off' : 'on');
    updateHaptics();
    if (!enabled) navigator.vibrate?.(20);
  });
  updateHaptics();

  const sound = document.getElementById('mute-btn');
  if (sound) {
    sound.classList.add('v2-icon-btn');
    const updateSound = () => {
      const enabled = window.SoundManager?.isEnabled?.() !== false;
      const label = t(enabled ? 'shell.soundOn' : 'shell.soundOff');
      sound.title = label;
      sound.setAttribute('aria-label', label);
      sound.setAttribute('aria-pressed', String(enabled));
      sound.innerHTML = icon(enabled ? 'sound' : 'soundOff');
    };
    sound.addEventListener('click', updateSound);
    updateSound();
  }

  controls.prepend(fullscreen);
  controls.prepend(haptics);
  controls.prepend(sidebar);
}

function addMobileNavigation() {
  const game = document.getElementById('game-screen');
  if (!game || game.querySelector('.mobile-game-nav')) return;

  const backdrop = document.createElement('button');
  backdrop.type = 'button';
  backdrop.className = 'game-sheet-backdrop';
  backdrop.setAttribute('aria-label', t('shell.close'));

  const nav = document.createElement('nav');
  nav.className = 'mobile-game-nav';
  nav.setAttribute('aria-label', t('shell.sidebar'));
  nav.innerHTML = Object.entries(panelMap)
    .map(([key]) => `<button type="button" data-game-panel="${key}">${icon(key)}<span>${t(`shell.${key}`)}</span></button>`)
    .join('');

  function close() {
    game.classList.remove('mobile-sheet-open');
    game.querySelectorAll('.game-sidebar > section').forEach((section) => section.classList.remove('mobile-active'));
    nav.querySelectorAll('button').forEach((button) => button.removeAttribute('aria-current'));
  }

  // Der Griff, an dem die Leiste hochgezogen wird (siehe setNavOpen).
  const handle = document.createElement('button');
  handle.type = 'button';
  handle.className = 'mobile-nav-handle';
  handle.setAttribute('aria-controls', 'mobile-game-nav');
  handle.innerHTML = '<span class="mobile-nav-handle-bar" aria-hidden="true"></span>';
  nav.id = 'mobile-game-nav';
  nav.prepend(handle);

  /**
   * Die Leiste ist auf dem Handy eingeklappt und wird bei Bedarf hochgezogen.
   *
   * Nutzerwunsch: „um mehr Platz zu gewinnen". Ausgeklappt nimmt sie 66 px
   * plus den Sicherheitsrand des Telefons, und das in jedem Spiel, die ganze
   * Partie lang — obwohl man sie nur braucht, um kurz in Spieler, Verlauf
   * oder Chat zu sehen. Eingeklappt bleibt ein schmaler Griff.
   *
   * Die Höhe steht in einer CSS-Variablen (`--mobile-nav-h`), nicht in jeder
   * Regel einzeln: Alles, was über der Leiste sitzt — der Spielbereich, die
   * Schubladen, die Kartenleisten von Garfeln, Rauswurf und Monopoly —
   * wandert so mit, statt mit einer Lücke in der Luft zu schweben.
   */
  function setNavOpen(open) {
    document.documentElement.classList.toggle('mobile-nav-offen', open);
    handle.setAttribute('aria-expanded', String(open));
    handle.setAttribute('aria-label', t(open ? 'shell.navClose' : 'shell.navOpen'));
    // Eingeklappt sind die Knöpfe nicht zu sehen — dann dürfen sie auch
    // nicht per Tab-Taste erreichbar sein.
    nav.querySelectorAll('[data-game-panel]').forEach((button) => {
      button.tabIndex = open ? 0 : -1;
    });
    if (!open) close();
    // Der Spielbereich wird größer oder kleiner, ohne dass sich das Fenster
    // ändert. Spiele, die ihre Höhe selbst ausrechnen (Kniffel-Quadro),
    // erfahren davon nur über ein Größenereignis — also eins schicken, wenn
    // die Animation durch ist.
    window.setTimeout(() => window.dispatchEvent(new Event('resize')), 260);
  }

  const isNavOpen = () => document.documentElement.classList.contains('mobile-nav-offen');

  /**
   * Hochwischen öffnet, Herunterwischen schließt — am Griff wie an der Leiste.
   *
   * Der Griff sitzt bewusst ÜBER dem Sicherheitsrand, nicht an der
   * physischen Unterkante: Ein Wisch vom äußersten Rand gehört auf iPhone und
   * Android dem Betriebssystem (nach Hause, App-Wechsel) und erreicht die
   * Seite gar nicht. Ein Tipp auf den Griff tut dasselbe wie ein Wisch — ein
   * Wisch allein wäre weder auffindbar noch für jeden bedienbar.
   */
  const SWIPE_PX = 22;
  let swipeStart = null;
  let swiped = false;

  nav.addEventListener('pointerdown', (event) => {
    swipeStart = event.clientY;
    swiped = false;
  });
  nav.addEventListener('pointermove', (event) => {
    if (swipeStart === null) return;
    const dy = event.clientY - swipeStart;
    if (dy < -SWIPE_PX && !isNavOpen()) {
      setNavOpen(true);
      swiped = true;
      swipeStart = null;
    } else if (dy > SWIPE_PX && isNavOpen()) {
      setNavOpen(false);
      swiped = true;
      swipeStart = null;
    }
  });
  const endSwipe = () => {
    swipeStart = null;
  };
  nav.addEventListener('pointerup', endSwipe);
  nav.addEventListener('pointercancel', endSwipe);

  handle.addEventListener('click', () => {
    if (swiped) {
      swiped = false;
      return;
    }
    setNavOpen(!isNavOpen());
  });

  backdrop.addEventListener('click', close);
  nav.addEventListener('click', (event) => {
    const button = event.target.closest('[data-game-panel]');
    if (!button) return;
    // Ein Wisch, der auf einem Knopf endete, ist kein Tipp auf den Knopf.
    if (swiped) {
      swiped = false;
      return;
    }
    const key = button.dataset.gamePanel;
    const section = game.querySelector(panelMap[key]);
    const alreadyOpen = section?.classList.contains('mobile-active');
    close();
    if (alreadyOpen || !section) return;
    // Wer eine Schublade öffnet — auch über den Chat-Einblender —, braucht
    // die Leiste, um zwischen den Schubladen zu wechseln.
    setNavOpen(true);
    game.classList.add('mobile-sheet-open');
    section.classList.add('mobile-active');
    section.classList.remove('collapsed');
    button.setAttribute('aria-current', 'page');
    section.querySelector('button, input, [tabindex]')?.focus({ preventScroll: true });
  });

  game.append(backdrop, nav);
  setNavOpen(false);
  watchChatForNewMessages(game, nav);
  markHandleOnUnreadChat(nav, handle);
  closeSheetWhenDialogOpens(game, close);
}

/**
 * Ungelesene Chatnachrichten am Griff zeigen, solange die Leiste zu ist.
 *
 * Die Zahl sitzt am Chat-Knopf — und der ist eingeklappt nicht zu sehen.
 * Ohne diesen Punkt käme eine Nachricht wieder lautlos an, genau das, was
 * die Zahl verhindern sollte.
 */
function markHandleOnUnreadChat(nav, handle) {
  const badge = nav.querySelector('.chat-unread-badge');
  if (!badge) return;
  const update = () => handle.classList.toggle('has-unread', !badge.hidden);
  new MutationObserver(update).observe(badge, { attributes: true, attributeFilter: ['hidden'] });
  update();
}

/**
 * Oeffnet ein Spiel einen Dialog, geht die Schublade zu.
 *
 * Gemeldet vom Sohn des Nutzers: „Wenn man auf Aktion geht und dann darin auf
 * ein weiteres Menu geht, dann verschwindet das Fenster von Aktion nicht.“
 * Auf dem Handy sind die Aktionen eine Schublade, die von unten hereinfaehrt.
 * Ein Dialog daraus — Handelsangebot, Karten abwerfen — legte sich neben sie
 * statt an ihre Stelle, und man sah beides halb.
 *
 * Bewusst im Rahmenwerk und nicht im Plugin: die Schublade gehoert dem
 * Rahmenwerk, das Plugin kennt sie nicht und soll sie nicht kennen muessen.
 * Erkannt wird an aria-modal, das jeder Dialog ohnehin tragen muss — so
 * braucht kein Plugin dafuer eine Zeile Code.
 */
function closeSheetWhenDialogOpens(game, close) {
  // Nicht ueber offsetParent pruefen: bei position:fixed ist der immer null,
  // und genau so sind Dialoge gebaut. Gemessen wird deshalb, ob das Element
  // ueberhaupt eine Flaeche auf der Seite belegt -- das deckt hidden,
  // display:none und ein leeres, weggeschaltetes Fenster gleichermassen ab.
  const sichtbar = (element) => !element.hidden && element.getClientRects().length > 0;

  const pruefen = () => {
    if (!game.classList.contains('mobile-sheet-open')) return;
    for (const dialog of document.querySelectorAll('[aria-modal="true"]')) {
      if (sichtbar(dialog)) {
        close();
        return;
      }
    }
  };

  new MutationObserver(pruefen).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['hidden', 'style', 'class'],
  });
}

/**
 * Neue Chatnachrichten melden, während man woanders schaut.
 *
 * Auf dem Handy liegt der Chat hinter einem Tab. Wer spielt, sieht ihn nicht —
 * eine Nachricht kam bisher völlig lautlos an. Gemeldet wird zweifach: eine
 * Zahl am Tab, die bleibt, bis man hinsieht, und ein kurzer Einblender mit dem
 * Anfang der Nachricht, der von selbst wieder geht. Ein Tipp darauf öffnet den
 * Chat.
 *
 * Bewusst im Rahmenwerk und nicht in einem Plugin: der Chat gehört allen
 * Spielen, und keines soll das noch einmal bauen müssen.
 */
function watchChatForNewMessages(game, nav) {
  const messages = game.querySelector('#chat-messages');
  const tab = nav.querySelector('[data-game-panel="chat"]');
  if (!messages || !tab) return;

  const badge = document.createElement('span');
  badge.className = 'chat-unread-badge';
  badge.hidden = true;
  tab.append(badge);

  const popover = document.createElement('button');
  popover.type = 'button';
  popover.className = 'chat-popover';
  popover.hidden = true;
  game.append(popover);

  let unread = 0;
  let hideTimer = null;

  const chatIsOpen = () =>
    game.querySelector('.chat-section')?.classList.contains('mobile-active') === true;

  function clear() {
    unread = 0;
    badge.hidden = true;
    popover.hidden = true;
    window.clearTimeout(hideTimer);
  }

  popover.addEventListener('click', () => {
    popover.hidden = true;
    tab.click();
  });
  tab.addEventListener('click', clear);

  const observer = new MutationObserver((records) => {
    if (chatIsOpen()) {
      clear();
      return;
    }
    const added = records
      .flatMap((record) => [...record.addedNodes])
      .filter((node) => node.nodeType === 1 && node.classList?.contains('chat-msg'));
    if (added.length === 0) return;

    unread += added.length;
    badge.textContent = unread > 9 ? '9+' : String(unread);
    badge.hidden = false;

    const latest = added[added.length - 1];
    const name = latest.querySelector('.chat-msg-name')?.textContent?.trim() ?? '';
    const text = latest.querySelector('.chat-msg-text')?.textContent?.trim() ?? '';
    popover.textContent = `${name} ${text}`.trim().slice(0, 90);
    popover.hidden = false;

    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(() => {
      popover.hidden = true;
    }, 5000);
  });

  observer.observe(messages, { childList: true });
}

function addLiveRegion() {
  if (document.getElementById('v2-live-region')) return;
  const region = document.createElement('div');
  region.id = 'v2-live-region';
  region.className = 'sr-only';
  region.setAttribute('role', 'status');
  region.setAttribute('aria-live', 'polite');
  document.body.appendChild(region);
}

const legacyTranslations = new Map([
  ['Game over', 'Spiel beendet'],
  ['Your fleet', 'Deine Flotte'],
  ['Unplaced ships', 'Nicht platzierte Schiffe'],
  ['Place your ships', 'Platziere deine Schiffe'],
  ['Waiting for opponent…', 'Warte auf den Gegner …'],
  ['Both ready — game starting', 'Beide bereit — das Spiel beginnt'],
  ['Your turn — fire!', 'Du bist am Zug — Feuer!'],
  ['Opponent', 'Gegner'],
  ['Spectating', 'Zuschauermodus'],
  ['Cash', 'Bargeld'],
  ['Career', 'Beruf'],
  ['Salary', 'Gehalt'],
  ['House', 'Haus'],
  ['Family', 'Familie'],
  ['Insurance', 'Versicherung'],
  ['Stock', 'Aktie'],
  ['Life tiles', 'Lebenssteine'],
  ['Retired', 'Im Ruhestand'],
  ['Roll dice', 'Würfeln'],
  ['End turn', 'Zug beenden'],
  ['Buy property', 'Grundstück kaufen'],
  ['Manage properties', 'Grundstücke verwalten'],
  ['Propose trade', 'Tausch vorschlagen'],
  ['Declare bankruptcy', 'Bankrott erklären'],
]);

function translateLegacyText(root) {
  if (!root || root.nodeType === Node.TEXT_NODE) {
    if (root?.parentElement?.closest('input, textarea, [contenteditable="true"], #chat-messages')) return;
    const raw = root?.nodeValue;
    const trimmed = raw?.trim();
    if (!trimmed) return;
    let translated = legacyTranslations.get(trimmed);
    if (!translated) {
      translated = trimmed
        .replace(/^Waiting for (.+)…$/, 'Warte auf $1 …')
        .replace(/^(.+)'s waters$/, 'Gewässer von $1')
        .replace(/^Phase (\d+)$/, 'Phase $1')
        .replace(/\bpoints\b/gi, 'Punkte')
        .replace(/\bcards\b/gi, 'Karten');
      if (translated === trimmed) return;
    }
    root.nodeValue = raw.replace(trimmed, translated);
    return;
  }
  if (root.nodeType !== Node.ELEMENT_NODE) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) translateLegacyText(node);
}

function enableLegacyLocalization() {
  translateLegacyText(document.body);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') translateLegacyText(record.target);
      for (const node of record.addedNodes) translateLegacyText(node);
    }
  });
  observer.observe(document.body, { subtree: true, childList: true, characterData: true });
}

export function initShell() {
  document.documentElement.classList.add('lan-games-v2');
  enhanceBranding();
  addHeaderControls();
  addMobileNavigation();
  addLiveRegion();
  enableLegacyLocalization();
}
